export default [
  {
    chineseName: '氢',
    color: '#c2e37b',
    eleType: 'IA族',
    englishName: 'H',
    id: 1,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氦',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'He',
    id: 2,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '锂',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'Li',
    id: 3,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '铍',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Be',
    id: 4,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '硼',
    color: '#c2e37b',
    eleType: 'IIIA族',
    englishName: 'B',
    id: 5,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '碳',
    color: '#c2e37b',
    eleType: 'IVA族',
    englishName: 'C',
    id: 6,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氮',
    color: '#c2e37b',
    eleType: 'VA族',
    englishName: 'N',
    id: 7,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氧',
    color: '#c2e37b',
    eleType: 'VIA族',
    englishName: 'O',
    id: 8,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氟',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'F',
    id: 9,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氖',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Ne',
    id: 10,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '钠',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'Na',
    id: 11,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '镁',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Mg',
    id: 12,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '铝',
    color: '#fcebb8',
    eleType: 'IIIA族',
    englishName: 'Al',
    id: 13,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '硅',
    color: '#c2e37b',
    eleType: 'IVA族',
    englishName: 'Si',
    id: 14,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '磷',
    color: '#c2e37b',
    eleType: 'VA族',
    englishName: 'P',
    id: 15,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '硫',
    color: '#c2e37b',
    eleType: 'VIA族',
    englishName: 'S',
    id: 16,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氯',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'Cl',
    id: 17,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氩',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Ar',
    id: 18,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '钾',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'K',
    id: 19,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '钙',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Ca',
    id: 20,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '钪',
    color: '#fcebb8',
    eleType: 'IIIB族',
    englishName: 'Sc',
    id: 21,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钛',
    color: '#fcebb8',
    eleType: 'IVB族',
    englishName: 'Ti',
    id: 22,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钒',
    color: '#fcebb8',
    eleType: 'VB族',
    englishName: 'V',
    id: 23,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铬',
    color: '#fcebb8',
    eleType: 'VIB族',
    englishName: 'Cr',
    id: 24,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锰',
    color: '#fcebb8',
    eleType: 'VIIB族',
    englishName: 'Mn',
    id: 25,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铁',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Fe',
    id: 26,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钴',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Co',
    id: 27,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镍',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Ni',
    id: 28,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铜',
    color: '#fcebb8',
    eleType: 'IB族',
    englishName: 'Cu',
    id: 29,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锌',
    color: '#fcebb8',
    eleType: 'IIB族',
    englishName: 'Zn',
    id: 30,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镓',
    color: '#fcebb8',
    eleType: 'IIIA族',
    englishName: 'Ga',
    id: 31,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '锗',
    color: '#fcebb8',
    eleType: 'IVA族',
    englishName: 'Ge',
    id: 32,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '砷',
    color: '#c2e37b',
    eleType: 'VA族',
    englishName: 'As',
    id: 33,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '硒',
    color: '#c2e37b',
    eleType: 'VIA族',
    englishName: 'Se',
    id: 34,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '溴',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'Br',
    id: 35,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氪',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Kr',
    id: 36,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '铷',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'Rb',
    id: 37,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '锶',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Sr',
    id: 38,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '钇',
    color: '#fcebb8',
    eleType: 'IIIB族',
    englishName: 'Y',
    id: 39,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锆',
    color: '#fcebb8',
    eleType: 'IVB族',
    englishName: 'Zr',
    id: 40,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铌',
    color: '#fcebb8',
    eleType: 'VB族',
    englishName: 'Nb',
    id: 41,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钼',
    color: '#fcebb8',
    eleType: 'VIB族',
    englishName: 'Mo',
    id: 42,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锝',
    color: '#fcebb8',
    eleType: 'VIIB族',
    englishName: 'Tc',
    id: 43,
    isClose: '0', // 人工合成元素
    type: '过渡元素'
  },
  {
    chineseName: '钌',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Ru',
    id: 44,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铑',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Rh',
    id: 45,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钯',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Pd',
    id: 46,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '银',
    color: '#fcebb8',
    eleType: 'IB族',
    englishName: 'Ag',
    id: 47,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镉',
    color: '#fcebb8',
    eleType: 'IIB族',
    englishName: 'Cd',
    id: 48,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铟',
    color: '#fcebb8',
    eleType: 'IIIA族',
    englishName: 'In',
    id: 49,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '锡',
    color: '#fcebb8',
    eleType: 'IVA族',
    englishName: 'Sn',
    id: 50,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '锑',
    color: '#fcebb8',
    eleType: 'VA族',
    englishName: 'Sb',
    id: 51,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '碲',
    color: '#c2e37b',
    eleType: 'VIA族',
    englishName: 'Te',
    id: 52,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '碘',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'I',
    id: 53,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氙',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Xe',
    id: 54,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '铯',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'Cs',
    id: 55,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '钡',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Ba',
    id: 56,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '镧',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'La',
    id: 57,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铈',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Ce',
    id: 58,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镨',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Pr',
    id: 59,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钕',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Nd',
    id: 60,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钷',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Pm',
    id: 61,
    isClose: '0', // 人工合成元素
    type: '过渡元素'
  },
  {
    chineseName: '钐',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Sm',
    id: 62,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铕',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Eu',
    id: 63,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钆',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Gd',
    id: 64,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铽',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Tb',
    id: 65,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镝',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Dy',
    id: 66,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钬',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Ho',
    id: 67,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铒',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Er',
    id: 68,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铥',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Tm',
    id: 69,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镱',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Yb',
    id: 70,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镥',
    color: '#fcebb8',
    eleType: '镧系',
    englishName: 'Lu',
    id: 71,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铪',
    color: '#fcebb8',
    eleType: 'IVB族',
    englishName: 'Hf',
    id: 72,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钽',
    color: '#fcebb8',
    eleType: 'VB族',
    englishName: 'Ta',
    id: 73,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钨',
    color: '#fcebb8',
    eleType: 'VIB族',
    englishName: 'W',
    id: 74,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铼',
    color: '#fcebb8',
    eleType: 'VIIB族',
    englishName: 'Re',
    id: 75,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锇',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Os',
    id: 76,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铱',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Ir',
    id: 77,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铂',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Pt',
    id: 78,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '金',
    color: '#fcebb8',
    eleType: 'IB族',
    englishName: 'Au',
    id: 79,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '汞',
    color: '#fcebb8',
    eleType: 'IIB族',
    englishName: 'Hg',
    id: 80,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铊',
    color: '#fcebb8',
    eleType: 'IIIA族',
    englishName: 'Tl',
    id: 81,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '铅',
    color: '#fcebb8',
    eleType: 'IVA族',
    englishName: 'Pb',
    id: 82,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '铋',
    color: '#fcebb8',
    eleType: 'VA族',
    englishName: 'Bi',
    id: 83,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '钋',
    color: '#fcebb8',
    eleType: 'VIA族',
    englishName: 'Po',
    id: 84,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '砹',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'At',
    id: 85,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '氡',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Rn',
    id: 86,
    isClose: '0',
    type: '稀有气体'
  },
  {
    chineseName: '钫',
    color: '#fcebb8',
    eleType: 'IA族',
    englishName: 'Fr',
    id: 87,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '镭',
    color: '#fcebb8',
    eleType: 'IIA族',
    englishName: 'Ra',
    id: 88,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '锕',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Ac',
    id: 89,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钍',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Th',
    id: 90,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镤',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Pa',
    id: 91,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铀',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'U',
    id: 92,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镎',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Np',
    id: 93,
    isClose: '0', // 人工合成元素
    type: '过渡元素'
  },
  {
    chineseName: '钚',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Pu',
    id: 94,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镅',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Am',
    id: 95,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锔',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Cm',
    id: 96,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锫',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Bk',
    id: 97,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锎',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Cf',
    id: 98,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锿',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Es',
    id: 99,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '镄',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Fm',
    id: 100,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '钔',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Md',
    id: 101,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '锘',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'No',
    id: 102,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '铹',
    color: '#fcebb8',
    eleType: '锕系',
    englishName: 'Lr',
    id: 103,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬬻',
    color: '#fcebb8',
    eleType: 'IVB族',
    englishName: 'Rf',
    id: 104,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬭊',
    color: '#fcebb8',
    eleType: 'VB族',
    englishName: 'Db',
    id: 105,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬭳',
    color: '#fcebb8',
    eleType: 'VIB族',
    englishName: 'Sg',
    id: 106,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬭛',
    color: '#fcebb8',
    eleType: 'VIIB族',
    englishName: 'Bh',
    id: 107,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬭶',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Hs',
    id: 108,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '鿏',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Mt',
    id: 109,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𫟼',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Ds',
    id: 110,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '𬬭',
    color: '#fcebb8',
    eleType: 'VIII族',
    englishName: 'Rg',
    id: 111,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '鎶',
    color: '#fcebb8',
    eleType: 'IIB族',
    englishName: 'Cn',
    id: 112,
    isClose: '0',
    type: '过渡元素'
  },
  {
    chineseName: '鉨',
    color: '#fcebb8',
    eleType: 'IIIA族',
    englishName: 'Nh',
    id: 113,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '𫓧',
    color: '#fcebb8',
    eleType: 'IVA族',
    englishName: 'Fl',
    id: 114,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '镆',
    color: '#fcebb8',
    eleType: 'VA族',
    englishName: 'Mc',
    id: 115,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '𫟷',
    color: '#fcebb8',
    eleType: 'VIA族',
    englishName: 'Lv',
    id: 116,
    isClose: '0',
    type: '金属元素'
  },
  {
    chineseName: '鿬',
    color: '#c2e37b',
    eleType: 'VIIA族',
    englishName: 'Ts',
    id: 117,
    isClose: '0',
    type: '非金属元素'
  },
  {
    chineseName: '鿫',
    color: '#b9f1fe',
    eleType: '0族',
    englishName: 'Og',
    id: 118,
    isClose: '0',
    type: '稀有气体'
  }
]
